import { render } from "./UserSidebar.vue?vue&type=template&id=581ee3e6&scoped=true&lang=true"
import script from "./UserSidebar.vue?vue&type=script&lang=js"
export * from "./UserSidebar.vue?vue&type=script&lang=js"

import "./UserSidebar.vue?vue&type=style&index=0&id=581ee3e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581ee3e6"]])

export default __exports__